import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
  (response) => {
    const version = localStorage.getItem('version');
    const listVersion = version?.length > 7 ? JSON?.parse(version) : version
    const versionRestaurants = version?.length > 7 ? listVersion?.auth_version : version
    const versionValidate = versionRestaurants > 4 ? JSON?.parse(versionRestaurants)?.length : JSON?.parse(version)?.length

    const currentVersion = response?.headers?.version;
    const objectVersions = {
      catalog_version: listVersion?.catalog_version,
      auth_version: listVersion?.auth_version,
      orders_version: listVersion?.orders_version,
      manufactures_version: listVersion?.manufactures_version,
      providers_version: listVersion?.providers_version,
      restaurants_Version: response?.headers?.version,
      cache_version: listVersion?.cache_version,
    }

    if (!versionRestaurants || versionRestaurants !== currentVersion) {
      localStorage.setItem('version', JSON.stringify(objectVersions));
    }

    if (
      versionValidate &&
      versionRestaurants !== currentVersion &&
      versionRestaurants !== null &&
      versionRestaurants !== 'undefined' &&
      currentVersion !== undefined
    ) {
      location.reload(true);
    }

    return response;
  },
  (error) => Promise.reject(error)
);

export default instance;
